import React, { useState, useEffect } from "react";
import Controls from "../../components/Controls"
import { getCVTData } from '../../services/TimeSeriesService'

import { getPointsForEquipment} from '../../services/MetadataService';
import { sendControls } from '../../services/ControlService';

const controllableTypes = ["Thermostat"]

 const LoadedControls = (props) => {
    const [controllableEquipment, setControllableEquipment] = useState()

    useEffect(() => {
        if (props.equipmentList && props.equipmentList.length > 0) {
            updateControllableEquipment();
        }
    }, [])

	const updateControllableEquipment = () => {
		let controllable = [];

		var yesterday = new Date();
		yesterday.setHours(-1)

		props.equipmentList.filter(e => controllableTypes.includes(e.type)).forEach(c => {
			//Get the points for this item
			getPointsForEquipment(c.equipment_id).then(response => {
				c["points"] = response
			})

			//Get the current telemetry for this equipment
			getCVTData(props.siteId, c.equipment_id).then(response => {
				console.log(response)
				c["data"] = {}
				response.forEach(point =>{
					c["data"][point.point_uuid] = point.value
				})
				controllable.push(c)
				setControllableEquipment(controllable)
				
			})
		})
	}

	const updateEquipmentControls = (equipment, controls) => {
		sendControls(props.siteId, equipment.equipment_id, controls).then(response => {
			setTimeout(function() {
				updateControllableEquipment();
			}, (10 * 1000));
		})
	}

	return (
		<div className="controls-container">
            {
                controllableEquipment && controllableEquipment.length > 0 ? 
                    controllableEquipment.map(ce => {
                        return <Controls equipment={ce} controlCallback={updateEquipmentControls} />
                    }) : null
            }
		</div>
	)
}

export default LoadedControls;
